import script from "./start.vue?vue&type=script&setup=true&lang=js"
export * from "./start.vue?vue&type=script&setup=true&lang=js"

import "./start.vue?vue&type=style&index=0&id=b23717aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23717aa"]])

export default __exports__